var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuiz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 853,
    height: 1024,
    viewBox: "0 0 853 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M849.067 409.6c-8.533-17.067-21.333-25.6-38.4-25.6h-337.067l38.4-337.067c4.267-17.067-8.533-38.4-25.6-42.667-17.067-8.533-38.4 0-51.2 12.8l-426.667 554.667c-8.533 12.8-12.8 29.867-4.267 46.933 8.533 12.8 21.333 21.333 38.4 21.333h337.067l-38.4 337.067c0 17.067 8.533 38.4 25.6 42.667 4.267 4.267 12.8 4.267 17.067 4.267 12.8 0 25.6-4.267 34.133-17.067l426.667-554.667c8.533-12.8 12.8-29.867 4.267-42.667z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuiz);
export default __webpack_public_path__ + "static/media/quiz.9d917a1efd42d799db25e53051c07153.svg";
export { ForwardRef as ReactComponent };